export default {
  actionToExecute: '执行的行动',
  addAction: '增加行动',
  addListToSequence: '将列表添加到序列中',
  addPerson: '增加人员',
  addPersonOrStep: '增加人员或步骤',
  addScheduleName: '添加时间表名称',
  addScheduleObservations: '增加附表意见',
  addStep: '增加步骤',
  addTask: '添加任务',
  addTrigger: '添加触发器',
  addUserToSequence: '将用户添加到序列中',
  automaticEmail: '自动邮件',
  changeUserFromSequence: '从序列中更改用户',
  companyName: '公司名称',
  completion: '完成情况',
  continueWithoutSaving: '继续，不保存',
  copyCustomizedField: '复制自定义字段',
  couldNotCopyFieldToClipboard: '无法将该字段复制到剪贴板',
  createAValidTask: '创建一个有效的任务',
  createRule: '创建规则',
  createSequence: '创建序列',
  customFieldSuccessfullyCopiedToClipboard: '自定义字段成功复制到剪贴板',
  customizeDay: '定制日',
  customizeScheduleDays: '自定义日程天数',
  dayDisabled: '残疾日',
  days: '天数',
  deleteAction: '删除行动',
  deleteList: '删除名单',
  deleteSequence: '删除序列',
  deleteTrigger: '删除触发器',
  deleteUserFromSequence: '从序列中删除用户',
  deleteUserFromSequenceConfirmation: '你真的想从序列中删除这个用户吗？',
  doNothing: '什么都不做',
  doYouReallyWanToDeleteThisSequence: '你真的想删除这个序列吗？',
  editList: '编辑列表',
  editPerson: '编辑人员',
  editRule: '编辑规则',
  editSchedule: '编辑时间表',
  emailHooksInformation: '电子邮件的钩子信息',
  emailStatistics: '电子邮件统计',
  enterRuleDescription: '输入规则说明',
  editSequence: '编辑顺序',
  editStep: '编辑步骤',
  enterRuleName: '输入规则名称',
  enterStepName: '输入步骤名称',
  enterStepOrder: '输入步骤顺序',
  enterStepTips: '输入步骤提示',
  enterTaskName: '输入任务名称',
  enterTriggerName: '输入触发器名称',
  executeAnotherActionInAGivenTime: '在特定时间内执行另一个动作',
  exitWhen: '退出时',
  goBackToTheSequence: '回到序列中去',
  hours: '时间',
  ifNotSequenceStepPickedNote: '注意：如果你不选择一个步骤，下一个序列步骤将被默认选择。',
  insertEmailSubject: '插入电子邮件主题',
  isActive: '是活跃的',
  isDayActive: '是日活跃',
  isGlobal: '是全球',
  isSequenceActive: '序列是否有效',
  isStepActive: '阶梯是否活跃',
  lastEditionDate: '最后版本日期',
  listNotFound: '未找到名单',
  listSuccessfullyAddedToSequence: '列表成功添加到序列中',
  listView: '列表视图',
  loadingInformation: '加载信息',
  loadingRule: '装载规则',
  loadingSchedule: '装载时间表',
  loadingSequence: '加载顺序',
  loadingSequenceStatistics: '加载序列统计',
  loadingStep: '加载步骤',
  manualEmail: '手动电子邮件',
  nestedActionToExecute: '执行嵌套动作',
  newRule: '新规则',
  newSchedule: '新时间表',
  newSequence: '新序列',
  noRulesCreated: '没有制定规则',
  noSchedulesCreated: '没有建立时间表',
  noSequencesCreated: '没有创建序列',
  order: '订购',
  owner: '业主',
  pauseSequence: '暂停序列',
  peopleInTheSequence: '顺序中的人',
  peoplePerStep: '每级人数',
  peopleThatLeftTheSequence: '离开序列的人',
  personSuccessfullyAddedToSequence: '人成功加入序列',
  personSuccessfullyChangedFromSequence: '人成功地从序列改变',
  personSuccessfullyCreated: '人成功创建',
  personSuccessfullyUpdated: '人员成功更新',
  pickAnAction: '选择一个动作',
  pickAnHour: '选择一个小时',
  pickADate: '选择一个日期',
  pickARule: '选择一个规则',
  pickASchedule: '选择一个时间表',
  pickAScheduleForTheSequence: '选择一个序列的时间表',
  pickAStep: '选择一个步骤',
  pickFinishingTime: '选择结束时间',
  pickHour: '选择时间',
  pickMinutes: '选择分钟',
  pickTimeZone: '选择时区',
  pickStartingDateTimeAndTimeZone: '选择开始日期、时间和时区',
  pickStartingTime: '选择开始时间',
  pickTheSequenceToChangeTo: '选择要更改的序列',
  pickTheStepToChangeTo: '选择要改变的步骤',
  pickTriggerType: '选择触发类型',
  prepareEmail: '准备电子邮件',
  project: '项目介绍',
  relateRuleToSequence: '将规则与序列相关联',
  relateRuleToSequenceOrSetAsGlobal: '将规则与序列或集合关联起来作为全局规则',
  removeUserFromSequence: '从序列中删除用户',
  ruleDetails: '规则细节',
  ruleNotFound: '未找到规则',
  ruleSuccessfullyCreated: '成功创建规则',
  ruleSuccessfullyUpdated: '成功更新规则',
  rules: '规则',
  runSequence: '运行顺序',
  saveTemplate: '保存模板',
  saveTemplateWarning: '您还没有保存或更新此模板，您确定不保存或更新就继续吗？',
  scheduleDays: '日程安排',
  scheduleName: '附表名称',
  scheduleObservations: '安排观察',
  scheduleSuccessfullyCreated: '计划表成功创建',
  scheduleSuccessfullyUpdated: '时间表成功更新',
  schedules: '时间表',
  seeList: '见清单',
  seePerson: '见人',
  seeSequence: '参见序列',
  selectARule: '选择一条规则',
  selectASequence: '选择一个序列',
  sequence: '序列',
  sequenceCompany: '序列公司',
  sequenceDetails: '序列细节',
  sequenceInformationWillBeLostAfterDeletionOfTheSequence: '所有的线索、步骤和与序列相关的任何信息将不再可用。',
  sequenceLeads: '顺序引导',
  sequenceName: '序列名称',
  sequenceOwner: '序列所有者',
  sequencePeople: '序列人',
  sequenceRuleType: '规则类型',
  sequenceSchedule: '序列时间表',
  sequenceStatistics: '序列统计',
  sequenceStatisticsNotFound: '未找到序列统计数据',
  sequenceStatus: '序列状态',
  sequenceStatusSuccessfullyChanged: '序列状态成功改变',
  sequenceSteps: '序列步骤',
  sequenceSuccessfullyCreated: '序列成功创建',
  sequenceSuccessfullyDeleted: '成功删除序列',
  sequenceSuccessfullyUpdated: '序列成功更新',
  sequences: '序列',
  sequencesRules: '序列规则',
  sequencesList: '序列列表',
  setRuleAsGlobal: '将规则设置为全局规则',
  sms: '短信',
  smsHooksInformation: 'Sms的钩子信息',
  smsStatistics: '短信统计',
  social: '社會的',
  settings: '设置',
  statistics: '统计数据',
  step: '步骤',
  stepSuccessfullyCreated: '步骤成功创建',
  stepSuccessfullyUpdated: '步骤成功更新',
  stepTips: '步骤提示',
  stepType: '步骤类型',
  task: '任务',
  taskHooksInformation: '任务的钩子信息',
  taskStatistics: '任务统计',
  templateSuccessfullySaved: '模板成功保存',
  templateSuccessfullyUpdated: '模板成功更新',
  theSequenceIsRunningNow: '顺序正在运行',
  timeToFinishTheTaskAfterRuleGetsExecuted: '规则执行后完成任务的时间',
  timeToWaitBeforeRunningThisStep: '在运行这一步之前，需要等待时间',
  timeToWaitBeforeNestedActionGetsExecuted: '嵌套动作被执行前的等待时间',
  tipsForTheStep: '技巧{type}',
  triggerName: '触发器名称',
  triggerActions: '触发行动',
  updateTemplateWarning: '模板{templateName} 要更新了，你确定吗？',
  userNotFound: '未找到用户',
  userSuccessfullyDeletedFromSequence: '用户成功从序列中删除',
  waitFor: '等待',
  withoutTips: '没有小费',
  writeEmail: '写邮件',
  writeSms: '编写短信',
  youMustFillAllFieldsCorrectly: '你必须正确填写所有的字段',
  youMustPickADate: '你必须选择一个日期',
  pickAnOutcome: '選擇結果',
  pickAnOutcomeForTheTask: '為任務選擇結果',
  deliveredPlural: '發表 | 發表',
  clickedPlural: '已點擊 | 已點擊',
  deferral: '遞延 | 遞延',
  hardBounced: '硬彈 | 硬彈',
  softBounced: '軟彈跳 | 軟彈跳',
  spamBlocked: '垃圾郵件被阻止 | 垃圾郵件被阻止',
  unsubscribed: '取消訂閱 | 取消訂閱',
  blackList: '黑名單',
  whiteList: '白名單',
  unknown: '未知 | 未知',
  pending: '待辦的 | 待辦的',
  scheduled: '預定的 | 預定的',
  queued: '排隊 | 排隊'
}
